import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

export const LayoutContext = React.createContext({});

let setValues;
export const LayoutProvider = ({ children }) => {
  const [contextValues, setContextValues] = useState([]);
  setValues = setContextValues;

  return <LayoutContext.Provider value={contextValues}>{children}</LayoutContext.Provider>;
};

LayoutProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useLayoutParams = (
  isDisplayHeader = false,
  isDisplayScreeningError = false,
  hasVerticalPagination = false,
  showSaveNClose = false,
  showResumeBtn = false
) => {
  const params = [
    isDisplayHeader,
    isDisplayScreeningError,
    hasVerticalPagination,
    showSaveNClose,
    showResumeBtn
  ];

  useEffect(() => {
    if (setValues) {
      setValues(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...params]);
};
